import { onMounted, onUnmounted } from "vue";

export const useExternalScript = (scriptSrc: string) => {
	const loadScript = () => {
		if (document.querySelector(`script[src='${scriptSrc}']`)) {
			return;
		}

		const script = document.createElement("script");
		script.type = "text/javascript";
		script.async = true;
		script.src = scriptSrc;

		document.body.appendChild(script);
		window.removeEventListener("scroll", loadScript);
	};

	const removeScript = () => {
		const script = document.querySelector(`script[src='${scriptSrc}']`);
		if (script) {
			script.remove();
		}
	};

	onMounted(() => {
		window.addEventListener("scroll", loadScript);
	});

	onUnmounted(() => {
		removeScript();
	});

	return {
		loadScript,
		removeScript
	};
};
